import React from 'react';
import PropTypes from 'prop-types';

import ResponsivePicture from '../../Elements/ResponsivePicture/ResponsivePicture';
import { breakpoints } from '../imageDefaults';
import { clipText } from '../helpers';
import { constructCn } from '../../../utilities/helperFunctions';

import './ArticleCard.scss';

const ArticleCard = ({ wink, title, description, image, location }) => {
    const winkText = wink ? <div className="wink-label">{wink}</div> : null;

    const descriptionText = description ? (
        <div className="article-card-description">
            {clipText(description, 67)}
        </div>
    ) : null;

    const contentWrapperCn = constructCn(
        'content-wrapper',
        location === 'miniFeed' && 'full-width'
    );

    return (
        <div className="component-UnifiedPostCard-ArticleCard">
            <ResponsivePicture
                breakpoints={breakpoints}
                cloudinaryID={image.src}
                alt={image.alt}
            />
            <div className={contentWrapperCn}>
                {winkText}
                <div className="article-card-title">{clipText(title, 110)}</div>
                {descriptionText}
            </div>
        </div>
    );
};

ArticleCard.propTypes = {
    wink: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.exact({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string,
    }).isRequired,
    location: PropTypes.string.isRequired,
};

ArticleCard.displayName = 'ArticleCard';

export default ArticleCard;
